/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SupplierLocationMappingListConfiguration,
    SupplierLocationMappingListConfigurationFromJSON,
    SupplierLocationMappingListConfigurationToJSON,
    SupplierLocationMappingListItem,
    SupplierLocationMappingListItemFromJSON,
    SupplierLocationMappingListItemToJSON,
    SupplierLocationMappingListQuery,
    SupplierLocationMappingListQueryFromJSON,
    SupplierLocationMappingListQueryToJSON,
} from '../models';

export interface ApiSupplierLocationMappingListDataPostRequest {
    supplierLocationMappingListQuery?: SupplierLocationMappingListQuery;
}

/**
 * no description
 */
export class SupplierLocationMappingListApi extends runtime.BaseAPI {

    /**
     */
    async apiSupplierLocationMappingListConfigurationGetRaw(): Promise<runtime.ApiResponse<SupplierLocationMappingListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierLocationMappingListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSupplierLocationMappingListConfigurationGet(): Promise<SupplierLocationMappingListConfiguration> {
        const response = await this.apiSupplierLocationMappingListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSupplierLocationMappingListDataPostRaw(requestParameters: ApiSupplierLocationMappingListDataPostRequest): Promise<runtime.ApiResponse<Array<SupplierLocationMappingListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SupplierLocationMappingList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierLocationMappingListQueryToJSON(requestParameters.supplierLocationMappingListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupplierLocationMappingListItemFromJSON));
    }

    /**
     */
    async apiSupplierLocationMappingListDataPost(requestParameters: ApiSupplierLocationMappingListDataPostRequest): Promise<Array<SupplierLocationMappingListItem>> {
        const response = await this.apiSupplierLocationMappingListDataPostRaw(requestParameters);
        return await response.value();
    }

}
